export const ROUTES = {
  home: '/',
  login: '/login',
  setPassword: '/set-password',
  sites: '/sites',
  billing: '/billing',
  transactions: '/transactions',
  disbursement: '/disbursement',
  administrators: '/administrators',
  notFound: '*',
} as const;
